var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-component",style:([{height: _vm.height + '!important'},{width: _vm.width + '!important'}])},[_c('div',{staticClass:"icon",class:{'icon-hover': _vm.cursorPointer},style:([{'-webkit-mask': 'url(' + _vm.imagePath(_vm.icon, _vm.iconType)+')'},
             {'mask': 'url(' + _vm.imagePath(_vm.icon, _vm.iconType)+')'},{width: _vm.width},
             {height: _vm.height},{backgroundColor: _vm.colorCode || _vm.colors[_vm.color] || _vm.colors.primary}])})])
}
var staticRenderFns = []

export { render, staticRenderFns }